module.exports = __webpack_public_path__ + "static/img/user.db93be33.png";